import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './ProgressBar.module.scss';
const ProgressBar = ({ initialWidth = '32px', currentPercent }) => {
    return (_jsxs("div", { className: styles.progressBar, "data-testid": "progress-bar", children: [_jsx("div", { className: styles.initialIndicator, style: { width: initialWidth } }), _jsx("div", { className: styles.progressIndicator, style: { width: `${currentPercent}%` } })] }));
};
export { ProgressBar };
